module Omni.Booker {
    NgModule.component("rateConfirmModal", {
        templateUrl: 'rate-confirm-modal.html',
        bindings: {
            message: "@",
            close: "&",
            dismiss: "&"
        },
        controller: function () {
            var $ctrl = this;

            $ctrl.$onInit = function () {
            };

            $ctrl.ok = function () {
                $ctrl.close({ $value: 'confirm' });
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };
        }
    });
}